import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class CommonRouteFunctionService {

  breadCrumb = new Subject()
  getComponentName(array, name) {
    const routeKeyArray = [];
    let index;
    for (let i = 0; i < array.length; i++) {
      routeKeyArray.push(Object.keys(array[i])[0]);
    }
    index = routeKeyArray.indexOf(name);
    return array[index][name];
  }

}
